"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const useTransparency_1 = __importDefault(require("../../hooks/useTransparency"));
const styles_1 = require("../header/styles");
const logo_1 = __importDefault(require("../logo"));
const ErrorHeader = () => {
    const { isTransparent } = (0, useTransparency_1.default)();
    return ((0, jsx_runtime_1.jsx)(styles_1.HeaderContainer, { isTransparent: isTransparent, "data-facil-iti": "header-container", children: (0, jsx_runtime_1.jsx)(styles_1.HeaderContent, { children: (0, jsx_runtime_1.jsxs)(styles_1.Modules, { isTransparent: isTransparent, children: [(0, jsx_runtime_1.jsx)(styles_1.StyledLeft, {}), (0, jsx_runtime_1.jsx)(styles_1.LogoWrapper, { children: (0, jsx_runtime_1.jsx)(logo_1.default, { loading: false }) })] }) }) }));
};
exports.default = ErrorHeader;
